<script setup lang="ts">
import medal1 from "~/assets/images/ranking/medal_1.png";
import medal2 from "~/assets/images/ranking/medal_2.png";
import medal3 from "~/assets/images/ranking/medal_3.png";
import medal4 from "~/assets/images/ranking/medal_4.png";
import medal5 from "~/assets/images/ranking/medal_5.png";

const medalImages: Record<number, string> = { 1: medal1, 2: medal2, 3: medal3, 4: medal4, 5: medal5 };

const props = withDefaults(
  defineProps<{
    rank: number;
    context?: "ranking" | "review";
  }>(),
  { context: "ranking" }
);

const medalSrc = computed(() => medalImages[props.rank] ?? medal4);
</script>

<template>
  <span class="medal" :class="`medal--${context}`">
    <img class="medal-icon" :src="medalSrc" alt="" />
  </span>
</template>

<style lang="scss" scoped>
.medal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: none;
}

.medal-icon {
  width: 100%;
  height: auto;
}

/* ランキング表内 */
.medal--ranking {
  width: 32px;
  height: 32px;
}

/* 口コミカード内 */
.medal--review {
  width: 40px;
  height: 40px;
}

@include media(pc) {
  .medal--review {
    width: 48px;
    height: 48px;
  }
}
</style>
